<template>
  <div class="modal tabstart" tabindex="0">
    <div class="modal__top-container">
      <h2 class="modal__heading">
        {{ $t("course_resume_modal").heading }}
      </h2>
      <div class="modal__animation-container">
        <app-lottie
          v-if="
            $store.state.shownModal2 === 'none' ||
              (showLottie1 && $store.state.modalNumber === 1)
          "
          :lottie="'puzzle'"
          class="modal__animation"
        ></app-lottie>
      </div>
    </div>
    <div class="modal__text-container">
      {{ $t("course_resume_modal").paragraph }}
      <div class="modal__button-container">
        <app-button
          @click="startCourseNew()"
          :text="$t('course_resume_modal').start_new_button"
          class="modal__button"
        ></app-button>
        <app-button
          @mousedown="continueCourse()"
          :text="$t('course_resume_modal').resume_button"
          class="modal__button"
        ></app-button>
      </div>
    </div>
    <app-button-x-round @click="toggleModal()"></app-button-x-round>
  </div>
</template>

<script>
import AppButton from "@/components/Atoms/Button.vue";
import AppButtonXRound from "@/components/Atoms/ButtonXRound.vue";
import AppLottie from "@/components/Views/Lottiecontainer.vue";

export default {
  name: "appRegisterForm",
  components: {
    AppButton,
    AppButtonXRound,
    AppLottie
  },
  data() {
    return {
      showLottie1: true,
      showLottie2: false,
      playAnimation: false
    };
  },
  methods: {
    continueCourse() {
      if (
        !(this.$store.state.chosenLesson in this.$store.state.userDataLectures)
      ) {
        this.$store.state.userDataLectures[this.$store.state.chosenLesson] = {};
      }

      this.$store.state.processedExercises = this.$store.state.userDataLectures[
        this.$store.state.chosenLesson
      ].processedExercises;

      if (this.$store.state.coursePageRequestedViaTOC > 0) {
        this.setPage(this.$store.state.coursePageRequestedViaTOC);
      } else {
        this.setPage(
          this.o([
            this.$store.state.userDataLectures,
            this.$store.state.chosenLesson,
            "firstUnprocessedPage",
            1
          ])
        );
      }
      this.toggleModal();
      if (this.$store.state.windowWidth < this.remToPx(189.1)) {
        this.$store.state.TOCisOpen = false;
      }

      this.$store.state.userWasAskedAboutSound = true;
    },
    startCourseNew() {
      this.$store.dispatch("resetLectureDataForFinishedCourse");
      if (
        !(this.$store.state.chosenLesson in this.$store.state.userDataLectures)
      ) {
        this.$store.state.userDataLectures[this.$store.state.chosenLesson] = {};
      }
      this.$store.state.userDataLectures[this.$store.state.chosenLesson][
        "started"
      ] = false;
      this.$store.state.userDataLectures[this.$store.state.chosenLesson][
        "firstUnprocessedPage"
      ] = 1;

      this.$store.dispatch("updateCourse");
      this.$store.dispatch("getUserData");
      this.$store.dispatch("createListOfProgressedCourses");

      if (this.$store.state.coursePageRequestedViaTOC > 0) {
        this.setPage(this.$store.state.coursePageRequestedViaTOC);
        if (this.$store.state.windowWidth < this.remToPx(189.1)) {
          this.$store.state.TOCisOpen = false;
        }
      } else {
        this.setPage(1);
      }
      this.toggleModal();

      this.$store.state.userWasAskedAboutSound = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "sass/main.scss";

.modal {
  width: 46rem;
  border-radius: 1rem;
  font-family: $font-primary;
  color: $color-white;
  background-color: $color-black;

  @include respond(tab-port) {
    width: 50rem;
  }

  @include respond(phone) {
    width: min(414px, 100vw - 1.5rem);
  }

  &:focus {
    outline: none;
  }

  &__top-container {
    height: 35.9rem;
  }

  &__heading {
    padding-top: 3.3rem;
    text-align: center;
    font-size: 3.2rem;
    line-height: 1;
    color: $color-white;

    @include respond(phone) {
      font-size: 3.3rem;
    }
  }

  &__animation-container {
    position: relative;
    margin: 4.1rem 0;
    transform: translate(calc(23rem - 50%), 2.85rem);
    width: 14.5rem;
    height: 14.5rem;
    border-radius: 50%;
    background-color: #131313;

    overflow: hidden;

    @include respond(tab-port) {
      transform: translate(calc(25rem - 50%), 2.85rem);
    }

    @include respond(phone) {
      transform: translate(calc(min(207px, 50vw - 0.75rem) - 50%), 1rem);
      margin: 4.55rem 0 7.35rem;
      width: 18.5rem;
      height: 18.5rem;
    }
  }

  &__animation {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-53.75%, -46.25%);
    width: 100%;

    @include respond(phone) {
      width: 97.297%;
    }
  }

  &__text-container {
    padding: 2.75rem 2.75rem 1.375rem;
    font-size: 2rem;
    background-color: #151515;

    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;

    @include respond(tab-port) {
      padding: 1.915rem 2.5rem 2.5rem 2.5rem;
      font-size: 2.4rem;
      line-height: 1.45;
    }

    @include respond(phone) {
      font-size: 2.6rem;
    }
  }

  &__button-container {
    margin-top: 2.75rem;
    width: max-content;
    transform: translateX(calc(46rem - 5.5rem - 100%));

    display: grid;
    grid-template-columns: 1fr max-content max-content;

    @include respond(tab-port) {
      transform: translateX(calc(50rem - 5rem - 100%));
    }

    @include respond(phone) {
      margin-top: 3.5rem;
      transform: translateX(calc(min(414px, 100vw) - 6.5rem - 100%));
    }
  }

  &__button {
    grid-column: 3 / 4;
    text-align: center;
    padding: 0.9rem 2rem;
    background-color: #333;

    @include respond(phone) {
      font-size: 2.6rem;
    }

    &:hover {
      background-color: #444;
    }

    &:first-child {
      grid-column: 2 / 3;
      text-decoration: underline;
      background-color: transparent;
      margin-right: 0.25rem;
    }
  }
}
</style>
